/**
 * @generated SignedSource<<5773d6804e19f46878d2e8f249934300>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MusicParseStatus = "ERROR" | "IN_PROGRESS" | "NOT_STARTED" | "SKIPPED" | "SUCCESS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type StaffSelectPageOverlay_sheet$data = {
  readonly id: string;
  readonly width: number;
  readonly height: number;
  readonly bar_finder_steps: ReadonlyArray<{
    readonly id: string;
    readonly status: MusicParseStatus;
    readonly data: {
      readonly bars?: ReadonlyArray<{
        readonly bar_id: string;
        readonly x: number;
        readonly y: number;
        readonly width: number;
        readonly height: number;
        readonly " $fragmentSpreads": FragmentRefs<"StaffSelectPageMask_barFinderBar">;
      }>;
    } | null;
  }>;
  readonly bar_finder_user_confirmation_steps: ReadonlyArray<{
    readonly id: string;
    readonly status: MusicParseStatus;
  }>;
  readonly " $fragmentType": "StaffSelectPageOverlay_sheet";
};
export type StaffSelectPageOverlay_sheet$key = {
  readonly " $data"?: StaffSelectPageOverlay_sheet$data;
  readonly " $fragmentSpreads": FragmentRefs<"StaffSelectPageOverlay_sheet">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StaffSelectPageOverlay_sheet",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": "bar_finder_steps",
      "args": [
        {
          "kind": "Literal",
          "name": "step_type",
          "value": "BAR_FINDER"
        }
      ],
      "concreteType": "MusicParseStep",
      "kind": "LinkedField",
      "name": "steps",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MusicParseStepDataBarFinderBar",
                  "kind": "LinkedField",
                  "name": "bars",
                  "plural": true,
                  "selections": [
                    {
                      "alias": "bar_id",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mask_storage_name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "x",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "y",
                      "storageKey": null
                    },
                    (v1/*: any*/),
                    (v2/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "StaffSelectPageMask_barFinderBar"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "MusicParseStepDataBarFinder",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "steps(step_type:\"BAR_FINDER\")"
    },
    {
      "alias": "bar_finder_user_confirmation_steps",
      "args": [
        {
          "kind": "Literal",
          "name": "step_type",
          "value": "BAR_FINDER_USER_CONFIRMATION"
        }
      ],
      "concreteType": "MusicParseStep",
      "kind": "LinkedField",
      "name": "steps",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": "steps(step_type:\"BAR_FINDER_USER_CONFIRMATION\")"
    }
  ],
  "type": "MusicSheet",
  "abstractKey": null
};
})();

(node as any).hash = "7793a748e5d42b6b428227b2da9c1f61";

export default node;
